var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLyf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 950.51 627.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ed6a71;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 950.51,
    height: 627.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 750.98,
    cy: 396.7,
    r: 29.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M512.69,213.14a1,1,0,0,0-1,1s-.14,119.74-.42,121.8c-3.77,28.43-32.76,48.89-63.73,38.21-16.93-5.84-30.63-25.71-30.63-43.62V214.11a1,1,0,0,0-1-1H359.32a1,1,0,0,0-1,1c0,6-.07,123.14-.07,123.14a94.55,94.55,0,0,0,94.6,94.43c37.76,0,51.35-14.73,65.84-27.27l-.08,14.43c0,8.71-7.15,24.49-22.35,34.23C455.79,479,403.16,455.5,383,440.77a1,1,0,0,0-1.48.38c-3,6.29-15.07,32.37-17.5,37.54a.89.89,0,0,0,.36,1.13c117.15,70.61,202,2.59,202-69.72,0-88.14,0-193.41,0-196a1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M345.77,395.67a122.33,122.33,0,0,1-7-17.33c-.19-.6-.38-1.21-.56-1.81a1,1,0,0,0-.94-.71H227.61a1,1,0,0,1-1-1V119.71a1,1,0,0,0-1-1H172.13a1,1,0,0,0-1,1V425.22a1,1,0,0,0,1,1H365.61a.64.64,0,0,0,.47-1.08A124.34,124.34,0,0,1,345.77,395.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M760.55,136.25a1,1,0,0,1,.45,1.29l-18.87,40.19a1,1,0,0,1-1.43.38,47.12,47.12,0,0,0-26.65-8.2h-3a29,29,0,0,0-10.58,2h0a29.29,29.29,0,0,0-18.7,27.31c0,.79,0,10.18,0,13.25a1,1,0,0,0,1,1h55a1,1,0,0,1,1,1v48.22a1,1,0,0,1-1,1h-54a1,1,0,0,0-1,1V425.22a1,1,0,0,1-1,1H628.21a1,1,0,0,1-1-1V264.55a1,1,0,0,0-1-1h-30a1,1,0,0,1-1-1V214.39a1,1,0,0,1,1-1h30a1,1,0,0,0,1-1s-.13-14.39-.13-16.4a76.29,76.29,0,0,1,14.79-45.27C652.15,136.79,684.7,98,760.55,136.25Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLyf);
export default __webpack_public_path__ + "static/media/LYF.3d689d06828809b064ca22701b7346cf.svg";
export { ForwardRef as ReactComponent };